<template>
  <nav></nav>
</template>
<script>
export default {
  name: "Navbar",
};
</script>